import React, { useEffect } from "react";

export default function BranchSelector({
  branches,
  selectedBranch,      // Cambiado: ahora es un objeto
  setSelectedBranch,   // Cambiado: recibe el objeto completo
  onConfirm,
  onClose,
  loading,
}) {
  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/40">
      <div className="bg-white w-full max-w-md rounded-lg shadow-xl p-6">
        <h3 className="text-lg font-bold mb-4 text-black text-center">
          Seleccione una Sucursal
        </h3>

        {loading ? (
          <div className="text-center py-8 text-gray-500">
            Cargando sucursales...
          </div>
        ) : branches.length === 0 ? (
          <div className="text-center py-8 text-gray-400 text-sm">
            No se encontraron sucursales disponibles.
          </div>
        ) : (
          <>
            <div className="max-h-[260px] overflow-y-auto pr-2 space-y-2">
              {branches.map((st) => (
                <label
                  key={st.bodegaId}
                  className={`
                    flex items-center gap-3 p-3 border rounded cursor-pointer
                    ${selectedBranch?.bodegaId === st.bodegaId
                      ? "border-brand-primary bg-brand-primary/10"
                      : "border-gray-300"}
                  `}
                >
                  <input
                    type="radio"
                    checked={selectedBranch?.bodegaId === st.bodegaId}
                    onChange={() => setSelectedBranch(st)}  // 👈 Guarda el objeto completo
                  />
                  <span className="text-sm text-gray-800">
                    {st.bodegaName}
                  </span>
                </label>
              ))}
            </div>

            <div className="flex justify-center gap-4 mt-6">
              <button
                onClick={onClose}
                className="px-6 py-2 text-gray-700 hover:text-gray-900 border border-gray-300 rounded"
              >
                Cancelar
              </button>

              <button
                onClick={onConfirm}
                className="px-6 py-2 bg-brand-primary text-white rounded font-semibold"
              >
                Confirmar
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}